import React from 'react';

// Images ko import karein
import htmlIcon from '../assets/img/html.png';
import cssIcon from '../assets/img/text.png';
import reactIcon from '../assets/img/science.png';
import phpIcon from '../assets/img/php.png';
import jsIcon from '../assets/img/js.png';
import wpIcon from '../assets/img/wordpress.png';
import shopifyIcon from '../assets/img/shopify.svg';

const Skills = () => {
  const skills = [
    { name: 'HTML', percentage: 100, icon: htmlIcon },
    { name: 'CSS', percentage: 95, icon: cssIcon },
    { name: 'React Js', percentage: 90, icon: reactIcon },
    { name: 'PHP', percentage: 85, icon: phpIcon },
    { name: 'JavaScript', percentage: 95, icon: jsIcon },
    { name: 'WordPress', percentage: 95, icon: wpIcon },
    { name: 'Shopify', percentage: 100, icon: shopifyIcon },
  ];

  return (
    <section className="portfolio_work" id="skills">
      <div className="portfolio_project_work text-center" data-aos="fade-up">
        <h2 className="project-heading">My Skills</h2>
        <p className="project-subheading">
          Transforming ideas into reality with modern web technologies and best practices.
        </p>
      </div>

      <div className="skills-widget-block">
        <div className="skills-widget">
          {skills.map((skill, index) => (
            <div key={index} className="skills-item" data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="skill-inner">
                <div className="skill-icon-box">
                  <img src={skill.icon} alt={skill.name} />
                </div>
                <div className="skill-number">{skill.percentage}%</div>
              </div>
              <p>{skill.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;